import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

import App from "./App";
// import reportWebVitals from './reportWebVitals';
import setupAxiosInterceptors from "./utils/axiosInterceptor";
import { initializeSignOzTracing } from "@echoteam/signoz-react";

// Signoz — only initialize in production to avoid BatchSpanProcessor timeout errors in dev
if (process.env.NODE_ENV === "production") {
  initializeSignOzTracing();
}

// Suppress unhandled BatchSpanProcessor timeout rejections (OpenTelemetry internals)
window.addEventListener("unhandledrejection", (event) => {
  if (event?.reason?.message === "Timeout") {
    event.preventDefault();
  }
});

setupAxiosInterceptors();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
